export default __webpack_public_path__ + "static/media/sampleImg_men.7f53c69f.png";